import {
  getOGOrder,
  addItemToNextBox,
  createFromItem,
  getOGCustomer,
  getOGUpcomingOrders,
  sortOGOrders,
} from '../subscription-modal/ordergroove-api-helper';

export default () => ({
  initialized: false,
  open: false,
  openModal() {
    this.open = true;
    setTimeout(addFocusTrap, 15);
  },
  closeModal() {
    this.open = false;
    const event = new CustomEvent('webhook-dsc-modal-closed');
    window.dispatchEvent(event);
  },
  addToNextBox() {
    ordergrooveAddToNextBox();
  },
  init() {
    if (this.initialized) return;
    this.initialized = true;
    const modal = document.querySelector('.dsc-custom-og-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    initializeOGAuth();

    window.addEventListener('webhook-close-dsc-modal', () => {
      this.closeModal();
    });
  },
});

// fireDlAddToNextBoxEvent function removed - using direct calls in the specific functions instead

async function addToNextBoxAsOneTime() {
  const productInfo = document.querySelector('.dsc-custom-ordergroove-ui');
  const nextOrder = window.ogUpcomingOrders.results[0];
  const orderId = nextOrder.public_id;
  const productId = productInfo.getAttribute('data-product-variant-id');
  const productSku = productInfo.getAttribute('data-product-variant-sku') || document.querySelector('input.product-variant-sku')?.value;
  await addItemToNextBox({
    order: orderId,
    product: productId,
    quantity: 1,
  });

  if (window.dsc && typeof window.dsc.fireDlAddToNextBoxEvent === 'function') {
    window.dsc.fireDlAddToNextBoxEvent(
      'add-one-time-to-next-box',
      productId,
      productSku,
      1
    );
  }
}

async function addToNextBoxAsSubscription() {
  const productInfo = document.querySelector('.dsc-custom-ordergroove-ui');
  const orderId = window.ogUpcomingOrders.results[0].public_id;
  const productId = productInfo.getAttribute('data-product-variant-id');
  const productSku = productInfo.getAttribute('data-product-variant-sku') || document.querySelector('input.product-variant-sku')?.value;
  const subscriptionFrequency = document.querySelector('#subscription-frequency');
  const subscriptionFrequencyValue = window.dsc.ogFrequencyMap[subscriptionFrequency.value];
  const response = await addItemToNextBox({
    order: orderId,
    product: productId,
    quantity: 1,
  });
  await createFromItem({
    item: response.public_id,
    every: subscriptionFrequencyValue,
  });

  // Fire analytics event
  if (window.dsc && typeof window.dsc.fireDlAddToNextBoxEvent === 'function') {
    window.dsc.fireDlAddToNextBoxEvent(
      'subscribe',
      productId,
      productSku,
      1,
      subscriptionFrequency.value
    );
  }
}

async function ordergrooveAddToNextBox() {
  const productInfo = document.querySelector('.dsc-custom-ordergroove-ui');
  const numberOfSellingPlans = productInfo.getAttribute('data-number-of-selling-plans');

  if (numberOfSellingPlans === '0') {
    await addToNextBoxAsOneTime();
  } else {
    const addOneTimeToNextBoxRadioButton = document.querySelector('#add-one-time-to-next-box-subscriber');
    const addSubscriptionToNextBoxRadioButton = document.querySelector('#subscribe-radio-button');

    if (addOneTimeToNextBoxRadioButton.checked) {
      await addToNextBoxAsOneTime();
    } else if (addSubscriptionToNextBoxRadioButton.checked) {
      await addToNextBoxAsSubscription();
    }
  }

  // Analytics events are now handled directly in the addToNextBoxAsOneTime and addToNextBoxAsSubscription functions

  if (window.ogUpcomingOrders && window.ogUpcomingOrders.results.length) {
    toggleInNextBoxMessageText(window.ogUpcomingOrders.results[0]);
  }

  window.dispatchEvent(new CustomEvent('close-dsc-modal'));
}

function addFocusTrap() {
  const addToNextBoxModal = document.querySelector('.dsc-custom-og-modal');

  const previousFocusElement = document.activeElement;
  const closeButtonElement = addToNextBoxModal.querySelector('.modal-close');
  const focusableElements = '[tabindex]:not([tabindex="-1"]), input, button, select';
  const modalFocusableElements = addToNextBoxModal.querySelectorAll(focusableElements);
  const firstFocusableElement = addToNextBoxModal.querySelectorAll(focusableElements)[0];
  modalFocusableElements[0].focus();
  const focusableContent = [closeButtonElement, ...modalFocusableElements];
  const lastFocusableElement = focusableContent[focusableContent.length - 1];

  function focusTrap(e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    let isEscPressed = e.key === 'Escape' || e.keyCode === 27;

    if (isEscPressed) {
      document.removeEventListener('keydown', focusTrap);
      previousFocusElement.focus();
      const event = new CustomEvent('webhook-close-dsc-modal');
      window.dispatchEvent(event);
    }

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
        e.stopPropagation();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }

  window.addEventListener('webhook-dsc-modal-closed', () => {
    // previousFocusElement.focus();
    addToNextBoxModal.removeEventListener('keydown', focusTrap);
  });

  addToNextBoxModal.addEventListener('keydown', focusTrap);
}

function showButton() {
  const purchaseOptions = document.querySelector('.dsc-custom-ordergroove-ui-options');
  purchaseOptions.classList.remove('hidden');
}

async function addDateToAddToNextBoxButton(nextOrder) {
  const addToNextBoxModalButton = document.querySelector('.add-to-next-box-modal-button');

  const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
  const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(userLocale, { month: 'short', day: 'numeric' });
  addToNextBoxModalButton.innerHTML = addToNextBoxModalButton.innerHTML.replace('{date}', `${nextOrderDate}`);

  const unsubscribeableProductHeader = document.querySelector('.unsubscribe-able-product-header');
  if (unsubscribeableProductHeader) {
    unsubscribeableProductHeader.innerHTML = unsubscribeableProductHeader.innerHTML.replace(
      '{date}',
      `${nextOrderDate}`,
    );
  }

  const addToNextBoxHeader = document.querySelector('.subscribe-able-product-header');
  if (addToNextBoxHeader) {
    const nextOrderDateWithYear = new Date(nextOrder.place).toLocaleDateString(userLocale, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    addToNextBoxHeader.innerHTML = addToNextBoxHeader.innerHTML.replace('{date}', `${nextOrderDateWithYear}`);
  }
}

async function toggleInNextBoxMessageText(nextOrder) {
  const productInfo = document.querySelector('.dsc-custom-ordergroove-ui');
  const ogNextOrder = await getOGOrder(nextOrder.public_id);
  const productsInNextOrder = ogNextOrder.results.reduce((result, { product }) => {
    result[product] = true;
    return result;
  }, {});
  const productId = productInfo.getAttribute('data-product-variant-id');
  const addToNextBoxModalButton = document.querySelector('.add-to-next-box-modal-button');
  const productInNextBoxMessage = document.querySelector('.in-next-box-message');
  const productInNextBoxMessageText = document.querySelector('.in-next-box-message-text');

  const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
  const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(userLocale, { month: 'short', day: 'numeric' });
  productInNextBoxMessageText.innerHTML = productInNextBoxMessageText.innerHTML.replace('{date}', `${nextOrderDate}`);
  if (productsInNextOrder[productId]) {
    addToNextBoxModalButton.classList.add('hidden');
    productInNextBoxMessage.classList.remove('hidden');
    return true;
  } else {
    addToNextBoxModalButton.classList.remove('hidden');
    productInNextBoxMessage.classList.add('hidden');
    return false;
  }
}

async function initializeOGAuth() {
  await window.dsc?.ensureSubscriberHydrated?.();

  const ogCustomer = await getOGCustomer(window?.dsc?.customerId);
  const ogUpcomingOrders = await getOGUpcomingOrders(window?.dsc?.customerId);

  if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
    sortOGOrders(ogUpcomingOrders.results);
  }
  window.ogCustomer = ogCustomer;
  window.ogUpcomingOrders = ogUpcomingOrders;

  const isUserWithSubscription = !!(ogCustomer && ogUpcomingOrders && ogUpcomingOrders.count > 0);

  if (isUserWithSubscription) {
    addDateToAddToNextBoxButton(ogUpcomingOrders.results[0]);

    if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
      await toggleInNextBoxMessageText(ogUpcomingOrders.results[0]);
    }
    showButton();
  }

  // NOTE: this is only to match OG behavior, feel free to remove after ab-test
  const productInfo = document.querySelector('.dsc-custom-ordergroove-ui');
  const subscriberAddToCartDefault = productInfo.getAttribute('data-default-purchase-option-subscribers-add-to-cart');
  if (subscriberAddToCartDefault === 'subscribe') {
    const addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const subscriptionFrequency = document.querySelector('#subscription-frequency');
    const sellingPlanId = subscriptionFrequency.value;
    const createHiddenInput = ({ id, name, value }) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.id = id;
      input.name = name;
      input.value = value;
      return input;
    };
    const sellingPlanInput = createHiddenInput({
      id: 'selling-plan-id',
      name: 'selling_plan',
      value: sellingPlanId,
    });
    addToCartForm.append(sellingPlanInput);
  }
}
